module.exports = __webpack_public_path__ + "images/blog/for_business/banner_sp_ef70c3288c987acb29aa08653fd69843.png";